<form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">

  <!-- Seções -->
  <div *ngFor="let section of sortedSections"
    class="border border-gray-200 rounded-lg overflow-hidden">

    <!-- Header da seção -->
    <div class="bg-gray-50 px-4 py-3 border-b border-gray-200">
      <h3 class="text-base font-semibold text-gray-800">{{ section.section_title }}</h3>
    </div>

    <!-- Perguntas da seção -->
    <div class="p-4 space-y-6">
      <div *ngFor="let question of section.questions" class="space-y-2">

        <!-- Label da pergunta -->
        <label class="block text-sm font-medium text-gray-700">
          {{ question.question_text }}
          <span *ngIf="question.is_required" class="text-red-500 ml-0.5">*</span>
        </label>

        <!-- ═══ REGION SELECTOR (renderizado no lugar de TEXT_INPUT para perguntas configuradas) ═══ -->
        <ng-container *ngIf="isRegionSelectorQuestion(question.id)">
          <!-- Botão "Adicionar/Editar" + chips das regiões selecionadas (mesmo padrão do "Regiões de Aplicação" do plano) -->
          <div>
            <div *ngIf="!isReadOnly" class="flex items-center gap-3">
              <button type="button"
                (click)="openRegionModal(question.id)"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-westetics-purple-800 bg-westetics-purple-50 border border-westetics-purple-200 rounded-lg hover:bg-westetics-purple-100 transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
                </svg>
                {{ (selectedRegions[question.id] || []).length > 0 ? 'Editar' : 'Adicionar' }}
              </button>
            </div>

            <!-- Chips das regiões selecionadas -->
            <div [class.mt-3]="!isReadOnly">
              <div *ngIf="(selectedRegions[question.id] || []).length > 0" class="flex flex-wrap gap-2">
                <span *ngFor="let region of selectedRegions[question.id]"
                  class="inline-flex items-start gap-1 px-3 py-1 rounded-2xl text-sm max-w-full"
                  [ngClass]="isReadOnly ? 'bg-gray-100 text-gray-800' : 'bg-westetics-purple-100 text-westetics-purple-800'">
                  <span class="min-w-0 break-all">{{ region }}</span>
                  <button *ngIf="!isReadOnly" type="button"
                    (click)="removeRegion(question.id, region)"
                    class="ml-1 mt-0.5 shrink-0 text-westetics-purple-600 hover:text-red-500 focus:outline-none">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </span>
              </div>
              <p *ngIf="(selectedRegions[question.id] || []).length === 0" class="text-sm text-gray-500">
                <ng-container *ngIf="!isReadOnly">Nenhuma região selecionada. Clique em "Adicionar" para selecionar.</ng-container>
                <ng-container *ngIf="isReadOnly">—</ng-container>
              </p>
            </div>
          </div>
          <p *ngIf="hasError(question.id) && !isReadOnly" class="text-xs text-red-600 mt-1">
            Selecione ao menos uma região.
          </p>

          <!-- Modal de Seleção de Regiões -->
          <div *ngIf="regionModalOpen[question.id]"
            class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overscroll-contain"
            (wheel)="$event.stopPropagation()"
            (touchmove)="$event.stopPropagation()">
            <div class="bg-white rounded-xl shadow-2xl w-full max-w-4xl flex flex-col" style="max-height: 85vh;"
              (wheel)="$event.stopPropagation()">

              <!-- Header do modal -->
              <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">{{ question.question_text }}</h3>
                  <p class="text-sm text-gray-500 mt-0.5">
                    {{ (selectedRegions[question.id] || []).length }} região(ões) selecionada(s)
                  </p>
                </div>
                <button type="button" (click)="closeRegionModal(question.id)"
                  class="text-gray-400 hover:text-gray-600 transition-colors">
                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>

              <!-- Campo de busca -->
              <div class="px-6 py-3 border-b border-gray-200 bg-gray-50 shrink-0">
                <div class="relative">
                  <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                  <input type="text"
                    placeholder="Filtrar regiões..."
                    [value]="regionSearchFilter[question.id] || ''"
                    (input)="onRegionSearchChange(question.id, $event)"
                    class="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800">
                </div>
              </div>

              <!-- Corpo do modal: duas colunas com scroll independente -->
              <div class="flex-1 min-h-0 flex flex-col overflow-hidden">
                <div class="flex-1 min-h-0 flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x divide-gray-200">

                  <!-- Coluna: Facial -->
                  <div class="flex-1 min-h-0 flex flex-col md:w-1/2">
                    <div class="px-4 py-3 bg-gray-50 border-b border-gray-200 shrink-0">
                      <h4 class="text-xs font-bold text-gray-500 uppercase tracking-wider">Facial</h4>
                    </div>
                    <div class="flex-1 min-h-0 overflow-y-auto overscroll-contain px-4 py-2">
                      <div *ngFor="let region of getFilteredFacialRegions(question.id); let regionIndex = index" class="flex items-center gap-2.5 py-1.5">
                        <input type="checkbox"
                          [id]="'incident-region-modal-facial-' + question.id + '-' + regionIndex"
                          [checked]="isRegionSelected(question.id, region)"
                          (change)="toggleRegion(question.id, region)"
                          [disabled]="isReadOnly"
                          class="w-4 h-4 shrink-0 text-westetics-purple-800 border-gray-300 rounded focus:ring-westetics-purple-800 cursor-pointer" />
                        <label [for]="'incident-region-modal-facial-' + question.id + '-' + regionIndex"
                          class="text-sm text-gray-700 cursor-pointer select-none">{{ region }}</label>
                      </div>
                      <div *ngIf="getFilteredFacialRegions(question.id).length === 0 && regionSearchFilter[question.id]"
                        class="text-sm text-gray-400 py-3 text-center">Nenhuma facial encontrada</div>
                    </div>
                  </div>

                  <!-- Coluna: Corporal -->
                  <div class="flex-1 min-h-0 flex flex-col md:w-1/2">
                    <div class="px-4 py-3 bg-gray-50 border-b border-gray-200 shrink-0">
                      <h4 class="text-xs font-bold text-gray-500 uppercase tracking-wider">Corporal</h4>
                    </div>
                    <div class="flex-1 min-h-0 overflow-y-auto overscroll-contain px-4 py-2">
                      <div *ngFor="let region of getFilteredCorporalRegions(question.id); let regionIndex = index" class="flex items-center gap-2.5 py-1.5">
                        <input type="checkbox"
                          [id]="'incident-region-modal-corporal-' + question.id + '-' + regionIndex"
                          [checked]="isRegionSelected(question.id, region)"
                          (change)="toggleRegion(question.id, region)"
                          [disabled]="isReadOnly"
                          class="w-4 h-4 shrink-0 text-westetics-purple-800 border-gray-300 rounded focus:ring-westetics-purple-800 cursor-pointer" />
                        <label [for]="'incident-region-modal-corporal-' + question.id + '-' + regionIndex"
                          class="text-sm text-gray-700 cursor-pointer select-none">{{ region }}</label>
                      </div>
                      <div *ngIf="getFilteredCorporalRegions(question.id).length === 0 && regionSearchFilter[question.id]"
                        class="text-sm text-gray-400 py-3 text-center">Nenhuma corporal encontrada</div>
                    </div>
                  </div>

                </div>

                <!-- Nenhum resultado global -->
                <div *ngIf="getFilteredFacialRegions(question.id).length === 0 && getFilteredCorporalRegions(question.id).length === 0 && regionSearchFilter[question.id]"
                  class="text-sm text-gray-500 py-4 px-6 text-center border-t border-gray-200 shrink-0">
                  Nenhuma região encontrada para "{{ regionSearchFilter[question.id] }}"
                </div>
              </div>

              <!-- Adicionar região personalizada + Botão Concluir -->
              <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 shrink-0">
                <!-- Região personalizada -->
                <div *ngIf="!isReadOnly" class="mb-3">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Adicionar região personalizada</label>
                  <div class="flex gap-2">
                    <input type="text"
                      [value]="customRegionInput[question.id] || ''"
                      (input)="customRegionInput[question.id] = $any($event.target).value"
                      (keyup.enter)="addCustomRegion(question.id)"
                      placeholder="Ex: Região específica..."
                      class="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-800">
                    <button type="button" (click)="addCustomRegion(question.id)"
                      class="px-4 py-2 text-sm bg-westetics-purple-800 text-white rounded-md hover:bg-westetics-purple-900 focus:outline-none transition-colors">
                      Adicionar
                    </button>
                  </div>

                  <!-- Lista de regiões personalizadas já adicionadas -->
                  <div *ngIf="getCustomRegionsList(question.id).length > 0" class="mt-3">
                    <p class="text-xs font-medium text-gray-600 mb-1.5">Regiões personalizadas adicionadas:</p>
                    <div class="flex flex-wrap gap-1.5">
                      <span *ngFor="let custom of getCustomRegionsList(question.id)"
                        class="inline-flex items-center gap-1.5 px-2 py-1 text-xs bg-westetics-purple-100 text-westetics-purple-900 rounded-md border border-westetics-purple-200">
                        <span>{{ custom }}</span>
                        <button type="button"
                          (click)="removeRegion(question.id, custom)"
                          [attr.aria-label]="'Remover ' + custom"
                          class="text-westetics-purple-800 hover:text-westetics-purple-900 focus:outline-none">
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                          </svg>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Botão concluir -->
                <button type="button" (click)="closeRegionModal(question.id)"
                  class="w-full px-4 py-2.5 text-sm font-medium bg-westetics-purple-800 text-white rounded-lg hover:bg-westetics-purple-900 focus:outline-none transition-colors">
                  Concluir
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ═══ TEXT_INPUT ═══ -->
        <ng-container *ngIf="question.type === 'TEXT_INPUT' && !isRegionSelectorQuestion(question.id)">
          <!-- Read-only: valor como texto -->
          <div *ngIf="isReadOnly"
            class="text-sm text-gray-900 py-1.5 break-words whitespace-pre-wrap">
            {{ getReadOnlyValue(question) }}
          </div>
          <!-- Editável -->
          <ng-container *ngIf="!isReadOnly">
            <input type="text"
              [formControlName]="question.id"
              [placeholder]="question.placeholder || 'Digite sua resposta...'"
              class="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800 transition-colors"
              [ngClass]="{
                'border-red-500 bg-red-50': hasError(question.id),
                'border-gray-300': !hasError(question.id)
              }">
            <p *ngIf="hasError(question.id)" class="text-xs text-red-600 mt-1">
              Este campo é obrigatório.
            </p>
          </ng-container>
        </ng-container>

        <!-- ═══ DATE ═══ -->
        <ng-container *ngIf="question.type === 'DATE'">
          <div *ngIf="isReadOnly" class="text-sm text-gray-900 py-1.5">
            {{ getReadOnlyValue(question) }}
          </div>
          <ng-container *ngIf="!isReadOnly">
            <input type="date"
              [formControlName]="question.id"
              class="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800 transition-colors"
              [ngClass]="{
                'border-red-500 bg-red-50': hasError(question.id),
                'border-gray-300': !hasError(question.id)
              }">
            <p *ngIf="hasError(question.id)" class="text-xs text-red-600 mt-1">
              Este campo é obrigatório.
            </p>
          </ng-container>
        </ng-container>

        <!-- ═══ TIME ═══ -->
        <ng-container *ngIf="question.type === 'TIME'">
          <div *ngIf="isReadOnly" class="text-sm text-gray-900 py-1.5">
            {{ getReadOnlyValue(question) }}
          </div>
          <ng-container *ngIf="!isReadOnly">
            <input type="time"
              [formControlName]="question.id"
              class="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800 transition-colors"
              [ngClass]="{
                'border-red-500 bg-red-50': hasError(question.id),
                'border-gray-300': !hasError(question.id)
              }">
            <p *ngIf="hasError(question.id)" class="text-xs text-red-600 mt-1">
              Este campo é obrigatório.
            </p>
          </ng-container>
        </ng-container>

        <!-- ═══ YES_NO ═══ -->
        <ng-container *ngIf="question.type === 'YES_NO'">
          <div *ngIf="isReadOnly" class="text-sm text-gray-900 py-1.5">
            {{ getReadOnlyYesNoValue(question.id) }}
          </div>
          <ng-container *ngIf="!isReadOnly">
            <div class="flex items-center gap-4">
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="radio" [formControlName]="question.id" value="SIM"
                  class="w-4 h-4 text-westetics-purple-800 focus:ring-westetics-purple-800 border-gray-300">
                <span class="text-sm text-gray-700">Sim</span>
              </label>
              <label class="flex items-center gap-2 cursor-pointer">
                <input type="radio" [formControlName]="question.id" value="NAO"
                  class="w-4 h-4 text-westetics-purple-800 focus:ring-westetics-purple-800 border-gray-300">
                <span class="text-sm text-gray-700">Não</span>
              </label>
            </div>
            <p *ngIf="hasError(question.id)" class="text-xs text-red-600 mt-1">
              Este campo é obrigatório.
            </p>
          </ng-container>
        </ng-container>

        <!-- ═══ SINGLE_CHOICE ═══ -->
        <ng-container *ngIf="question.type === 'SINGLE_CHOICE'">
          <!-- Read-only: só o valor selecionado -->
          <div *ngIf="isReadOnly">
            <div class="text-sm text-gray-900 py-1.5">{{ getReadOnlySingleChoiceText(question) }}</div>
            <div *ngIf="getReadOnlyObservation(question.id)" class="mt-2 ml-2 pl-3 border-l-2 border-gray-300">
              <span class="text-xs font-medium text-gray-500 block mb-0.5">Observação</span>
              <span class="text-sm text-gray-900 break-words whitespace-pre-wrap">{{ getReadOnlyObservation(question.id) }}</span>
            </div>
            <!-- Sub-perguntas da opção selecionada (read-only) -->
            <ng-container *ngFor="let option of getSortedOptions(question)">
              <div *ngIf="option.sub_questions && option.sub_questions.length > 0 && isOptionSelected(question, option)"
                class="mt-2 ml-2 pl-3 border-l-2 border-gray-200 space-y-3">
                <ng-container *ngFor="let subQ of option.sub_questions">
                  <ng-container *ngTemplateOutlet="subQuestionTpl; context: { $implicit: subQ }"></ng-container>
                </ng-container>
              </div>
            </ng-container>
          </div>
          <!-- Editável -->
          <ng-container *ngIf="!isReadOnly">
            <div class="space-y-2">
              <div *ngFor="let option of getSortedOptions(question)">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" [formControlName]="question.id" [value]="option.id"
                    (change)="onSingleChoiceChange(question, option.id)"
                    class="w-4 h-4 text-westetics-purple-800 focus:ring-westetics-purple-800 border-gray-300">
                  <span class="text-sm text-gray-700">{{ option.option_text }}</span>
                </label>
                <!-- Observação inline: aparece logo abaixo da opção que a ativou -->
                <div *ngIf="isOptionTriggeringObservation(question, option)"
                  class="mt-2 ml-6 pl-4 border-l-2 border-westetics-purple-800">
                  <label class="block text-sm font-medium text-gray-600 mb-1">Observação</label>
                  <textarea
                    [formControlName]="question.id + '_observation'"
                    placeholder="Descreva com mais detalhes..."
                    rows="2"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800 transition-colors">
                  </textarea>
                </div>
                <!-- Sub-perguntas da opção selecionada -->
                <div *ngIf="option.sub_questions && option.sub_questions.length > 0 && isOptionSelected(question, option)"
                  class="mt-2 ml-6 pl-4 border-l-2 border-purple-300 space-y-4">
                  <ng-container *ngFor="let subQ of option.sub_questions">
                    <ng-container *ngTemplateOutlet="subQuestionTpl; context: { $implicit: subQ }"></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            <p *ngIf="hasError(question.id)" class="text-xs text-red-600 mt-1">
              Este campo é obrigatório.
            </p>
          </ng-container>
        </ng-container>

        <!-- ═══ MULTIPLE_CHOICE ═══ -->
        <ng-container *ngIf="question.type === 'MULTIPLE_CHOICE'">
          <!-- Read-only: lista das opções marcadas -->
          <div *ngIf="isReadOnly">
            <ul *ngIf="getReadOnlyMultipleChoiceItems(question).length > 0" class="list-disc ml-5 text-sm text-gray-900 space-y-0.5">
              <li *ngFor="let item of getReadOnlyMultipleChoiceItems(question)">{{ item }}</li>
            </ul>
            <div *ngIf="getReadOnlyMultipleChoiceItems(question).length === 0" class="text-sm text-gray-900 py-1.5">—</div>
            <div *ngIf="getReadOnlyObservation(question.id)" class="mt-2 ml-2 pl-3 border-l-2 border-gray-300">
              <span class="text-xs font-medium text-gray-500 block mb-0.5">Observação</span>
              <span class="text-sm text-gray-900 break-words whitespace-pre-wrap">{{ getReadOnlyObservation(question.id) }}</span>
            </div>
            <!-- Sub-perguntas das opções selecionadas (read-only) -->
            <ng-container *ngFor="let option of getSortedOptions(question); let i = index">
              <div *ngIf="option.sub_questions && option.sub_questions.length > 0 && isOptionSelected(question, option, i)"
                class="mt-2 ml-2 pl-3 border-l-2 border-gray-200 space-y-3">
                <ng-container *ngFor="let subQ of option.sub_questions">
                  <ng-container *ngTemplateOutlet="subQuestionTpl; context: { $implicit: subQ }"></ng-container>
                </ng-container>
              </div>
            </ng-container>
          </div>
          <!-- Editável -->
          <ng-container *ngIf="!isReadOnly">
            <div class="space-y-2" [formArrayName]="question.id">
              <div *ngFor="let option of getSortedOptions(question); let i = index">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" [formControlName]="i"
                    (change)="onMultipleChoiceChange(question)"
                    class="w-4 h-4 text-westetics-purple-800 focus:ring-westetics-purple-800 border-gray-300 rounded">
                  <span class="text-sm text-gray-700">{{ option.option_text }}</span>
                </label>
                <!-- Observação inline: aparece logo abaixo da opção que a ativou -->
                <div *ngIf="isMultipleOptionTriggeringObservation(question, option, i)"
                  class="mt-2 ml-6 pl-4 border-l-2 border-westetics-purple-800">
                  <label class="block text-sm font-medium text-gray-600 mb-1">Observação</label>
                  <textarea
                    [formControlName]="question.id + '_observation'"
                    placeholder="Descreva com mais detalhes..."
                    rows="2"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800 transition-colors">
                  </textarea>
                </div>
                <!-- Sub-perguntas da opção selecionada -->
                <div *ngIf="option.sub_questions && option.sub_questions.length > 0 && isOptionSelected(question, option, i)"
                  class="mt-2 ml-6 pl-4 border-l-2 border-purple-300 space-y-4">
                  <ng-container *ngFor="let subQ of option.sub_questions">
                    <ng-container *ngTemplateOutlet="subQuestionTpl; context: { $implicit: subQ }"></ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            <p *ngIf="hasError(question.id)" class="text-xs text-red-600 mt-1">
              Selecione ao menos uma opção.
            </p>
          </ng-container>
        </ng-container>

        <!-- ═══ OBJECT ═══ -->
        <ng-container *ngIf="question.type === 'OBJECT'">
          <!-- Read-only: tabela -->
          <div *ngIf="isReadOnly">
            <div *ngIf="getObjectEntriesArray(question.id).controls.length === 0" class="text-sm text-gray-500 py-1.5">
              Nenhum registro
            </div>
            <table *ngIf="getObjectEntriesArray(question.id).controls.length > 0"
              class="w-full text-sm border border-gray-200 rounded-md overflow-hidden">
              <thead class="bg-gray-50">
                <tr>
                  <th *ngFor="let field of getSortedObjectFields(question)"
                    class="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider border-b border-gray-200">
                    {{ field.field_label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let entryCtrl of getObjectEntriesArray(question.id).controls; let entryIdx = index"
                  class="even:bg-gray-50/50">
                  <td *ngFor="let field of getSortedObjectFields(question)"
                    class="px-3 py-2 text-gray-900 border-b border-gray-100 align-top">
                    {{ entryCtrl.get(field.field_key)?.value || '—' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Editável -->
          <ng-container *ngIf="!isReadOnly">
            <div class="space-y-3">
              <!-- Entradas existentes -->
              <div *ngFor="let entryCtrl of getObjectEntriesArray(question.id).controls; let entryIdx = index"
                class="border border-purple-200 rounded-lg p-4 bg-purple-50 relative">
                <!-- Header da entrada -->
                <div class="flex items-center justify-end">
                  <button type="button" (click)="removeObjectEntry(question.id, entryIdx)"
                    class="p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                    title="Remover">
                    <fa-icon [icon]="faTimes" size="sm"></fa-icon>
                  </button>
                </div>
                <!-- Campos do objeto -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3" [formArrayName]="question.id">
                  <ng-container [formGroupName]="entryIdx">
                    <div *ngFor="let field of getSortedObjectFields(question)">
                      <label class="block text-xs font-medium text-gray-600 mb-0.5">
                        {{ field.field_label }}
                        <span *ngIf="field.is_required" class="text-red-500">*</span>
                      </label>
                      <!-- SELECT -->
                      <select *ngIf="field.field_type === 'SELECT'"
                        [formControlName]="field.field_key"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800 transition-colors">
                        <option value="">{{ field.placeholder || 'Selecione...' }}</option>
                        <option *ngFor="let opt of field.select_options" [value]="opt">{{ opt }}</option>
                      </select>
                      <!-- TEXT, NUMBER, TIME, DATE -->
                      <input *ngIf="field.field_type !== 'SELECT'"
                        [type]="getObjectFieldInputType(field.field_type)"
                        [formControlName]="field.field_key"
                        [placeholder]="field.placeholder || ''"
                        class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-westetics-purple-800 focus:border-westetics-purple-800 transition-colors">
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Botão adicionar entrada -->
              <button type="button" (click)="addObjectEntry(question)"
                class="w-full py-2.5 border-2 border-dashed border-purple-300 rounded-lg text-westetics-purple-800 hover:border-westetics-purple-800 hover:bg-purple-50 text-sm font-medium transition-colors flex items-center justify-center gap-2">
                <fa-icon [icon]="faPlus" size="sm"></fa-icon>
                Adicionar item
              </button>
            </div>
            <p *ngIf="hasError(question.id)" class="text-xs text-red-600 mt-1">
              Adicione ao menos um item.
            </p>
          </ng-container>
        </ng-container>

      </div>
    </div>
  </div>

  <!-- ═══ Seção de Anexos ═══ -->
  <div class="border border-gray-200 rounded-lg overflow-hidden">
    <div class="bg-gray-50 px-4 py-3 border-b border-gray-200">
      <h3 class="text-base font-semibold text-gray-800">Anexos</h3>
      <p class="text-xs text-gray-500 mt-0.5">Adicione fotos, documentos ou vídeos relacionados à intercorrência</p>
    </div>
    <div class="p-4">
      <app-incident-attachment
        [existingAttachments]="existingAttachments"
        [treatmentPlanId]="treatmentPlanId"
        [readOnly]="isReadOnly"
        (attachmentsChange)="onAttachmentsChange($event)">
      </app-incident-attachment>
    </div>
  </div>

  <!-- ═══ Template reutilizável para sub-perguntas ═══ -->
  <ng-template #subQuestionTpl let-subQ>
    <div class="space-y-1.5 py-1">
      <label class="block text-sm font-medium text-gray-600">
        {{ subQ.question_text }}
        <span *ngIf="subQ.is_required" class="text-red-500 ml-0.5">*</span>
      </label>

      <!-- Read-only: valor único formatado por tipo -->
      <ng-container *ngIf="isReadOnly">
        <ng-container [ngSwitch]="subQ.type">
          <div *ngSwitchCase="'TEXT_INPUT'" class="text-sm text-gray-900 py-1 break-words whitespace-pre-wrap">
            {{ getReadOnlyValue(subQ) }}
          </div>
          <div *ngSwitchCase="'DATE'" class="text-sm text-gray-900 py-1">{{ getReadOnlyValue(subQ) }}</div>
          <div *ngSwitchCase="'TIME'" class="text-sm text-gray-900 py-1">{{ getReadOnlyValue(subQ) }}</div>
          <div *ngSwitchCase="'YES_NO'" class="text-sm text-gray-900 py-1">{{ getReadOnlyYesNoValue(subQ.id) }}</div>
          <div *ngSwitchCase="'SINGLE_CHOICE'" class="text-sm text-gray-900 py-1">{{ getReadOnlySingleChoiceText(subQ) }}</div>
          <div *ngSwitchCase="'MULTIPLE_CHOICE'">
            <ul *ngIf="getReadOnlyMultipleChoiceItems(subQ).length > 0" class="list-disc ml-5 text-sm text-gray-900 space-y-0.5">
              <li *ngFor="let item of getReadOnlyMultipleChoiceItems(subQ)">{{ item }}</li>
            </ul>
            <div *ngIf="getReadOnlyMultipleChoiceItems(subQ).length === 0" class="text-sm text-gray-900 py-1">—</div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Editável -->
      <ng-container *ngIf="!isReadOnly">
        <!-- TEXT_INPUT sub -->
        <ng-container *ngIf="subQ.type === 'TEXT_INPUT'">
          <input type="text"
            [formControlName]="subQ.id"
            [placeholder]="subQ.placeholder || 'Digite sua resposta...'"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-colors">
        </ng-container>

        <!-- DATE sub -->
        <ng-container *ngIf="subQ.type === 'DATE'">
          <input type="date" [formControlName]="subQ.id"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400">
        </ng-container>

        <!-- TIME sub -->
        <ng-container *ngIf="subQ.type === 'TIME'">
          <input type="time" [formControlName]="subQ.id"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400">
        </ng-container>

        <!-- YES_NO sub -->
        <ng-container *ngIf="subQ.type === 'YES_NO'">
          <div class="flex items-center gap-4">
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="radio" [formControlName]="subQ.id" value="SIM"
                class="w-4 h-4 text-purple-600 focus:ring-purple-400 border-gray-300">
              <span class="text-sm text-gray-700">Sim</span>
            </label>
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="radio" [formControlName]="subQ.id" value="NAO"
                class="w-4 h-4 text-purple-600 focus:ring-purple-400 border-gray-300">
              <span class="text-sm text-gray-700">Não</span>
            </label>
          </div>
        </ng-container>

        <!-- SINGLE_CHOICE sub -->
        <ng-container *ngIf="subQ.type === 'SINGLE_CHOICE'">
          <div class="space-y-1">
            <label *ngFor="let opt of getSortedOptions(subQ)" class="flex items-center gap-2 cursor-pointer">
              <input type="radio" [formControlName]="subQ.id" [value]="opt.id"
                class="w-4 h-4 text-purple-600 focus:ring-purple-400 border-gray-300">
              <span class="text-sm text-gray-700">{{ opt.option_text }}</span>
            </label>
          </div>
        </ng-container>

        <!-- MULTIPLE_CHOICE sub -->
        <ng-container *ngIf="subQ.type === 'MULTIPLE_CHOICE'">
          <div class="space-y-1" [formArrayName]="subQ.id">
            <label *ngFor="let opt of getSortedOptions(subQ); let si = index" class="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" [formControlName]="si"
                class="w-4 h-4 text-purple-600 focus:ring-purple-400 border-gray-300 rounded">
              <span class="text-sm text-gray-700">{{ opt.option_text }}</span>
            </label>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>

  <!-- Banner de intercorrência finalizada -->
  <div *ngIf="incidentStatus === 'CLOSED'" class="flex items-center gap-3 p-4 bg-amber-50 border border-amber-200 rounded-lg">
    <fa-icon [icon]="faLock" class="text-amber-600 text-lg"></fa-icon>
    <div>
      <p class="text-sm font-semibold text-amber-800">Intercorrência finalizada</p>
      <p class="text-xs text-amber-600">Este relatório foi finalizado e não pode mais ser editado.</p>
    </div>
  </div>

  <!-- Botões de ação (ocultos quando o pai gerencia via header) -->
  <div *ngIf="!isReadOnly && !hideActions" class="flex flex-wrap items-center justify-end gap-3 pt-4">
    <!-- Botão Salvar -->
    <button type="submit" [disabled]="saving || finalizing"
      class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed">
      <fa-icon *ngIf="!saving" [icon]="faSave" class="mr-2"></fa-icon>
      <span *ngIf="saving" class="mr-2">
        <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      </span>
      {{ saving ? 'Salvando...' : 'Salvar Intercorrência' }}
    </button>

    <!-- Botão Finalizar (só aparece após salvar e enquanto não finalizado) -->
    <button *ngIf="incidentId && incidentStatus !== 'CLOSED'" type="button" (click)="openFinalizeConfirm()" [disabled]="saving || finalizing"
      class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed">
      <fa-icon *ngIf="!finalizing" [icon]="faLock" class="mr-2"></fa-icon>
      <span *ngIf="finalizing" class="mr-2">
        <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      </span>
      {{ finalizing ? 'Finalizando...' : 'Finalizar Intercorrência' }}
    </button>
  </div>

  <!-- Botões de intercorrência finalizada (visíveis mesmo em read-only) -->
  <div *ngIf="incidentId && incidentStatus === 'CLOSED' && !hideActions" class="flex flex-wrap items-center justify-end gap-3 pt-4">
    <button type="button" (click)="onDownloadPdf()"
      class="px-4 py-2 text-sm font-medium text-westetics-purple-800 bg-white border border-westetics-purple-800 rounded-lg hover:bg-westetics-purple-50 transition-colors flex items-center">
      <fa-icon [icon]="faDownload" class="mr-2"></fa-icon>
      Baixar PDF
    </button>
    <button type="button" (click)="onResendAutentiqueEmail()"
      class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors flex items-center">
      <fa-icon [icon]="faLock" class="mr-2"></fa-icon>
      Reenviar por e-mail
    </button>
  </div>

</form>

<!-- ═══ Popup de confirmação de finalização ═══ -->
<div *ngIf="showFinalizeConfirm"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
  (click)="closeFinalizeConfirm()">

  <div class="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex items-center gap-3 p-5 border-b border-gray-200 bg-westetics-purple-50">
      <div class="w-10 h-10 rounded-full bg-westetics-purple-100 flex items-center justify-center flex-shrink-0">
        <fa-icon [icon]="faExclamationTriangle" class="text-westetics-purple-600 text-lg"></fa-icon>
      </div>
      <h3 class="text-lg font-semibold text-gray-900">Atenção: Esta ação é irreversível</h3>
    </div>

    <!-- Body -->
    <div class="p-5">
      <p class="text-sm text-gray-600 leading-relaxed">
        Ao finalizar, a intercorrência será <strong class="text-gray-800">bloqueada para edições</strong>
        e encaminhada imediatamente para o <strong class="text-gray-800">e-mail legal da clínica</strong>
        para assinatura.
      </p>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 p-5 border-t border-gray-200 bg-gray-50">
      <button type="button" (click)="closeFinalizeConfirm()"
        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
        Cancelar
      </button>
      <button type="button" (click)="confirmFinalize()"
        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600 transition-colors flex items-center gap-2">
        <fa-icon [icon]="faLock"></fa-icon>
        Finalizar Intercorrência
      </button>
    </div>
  </div>
</div>
